import { useEffect } from "react";
import { t } from "i18next";
import { Button, Card } from "react-bootstrap";
import useDetailsAction from "@bloonde/billing/invoice-accounts/actions/details/useDetailsAction";

function InvoiceAccountMainTab(props: {
  formDefaultValues: { entity_id: string; entity_type: string };
}) {
  const { formDefaultValues } = props;

  const { getFunction, onSubmitFunction, actionTemplate } = useDetailsAction(
    parseInt(formDefaultValues.entity_id),
    formDefaultValues.entity_type,
    formDefaultValues
  );

  useEffect(() => {
    if (!formDefaultValues.entity_id || !formDefaultValues.entity_type) return;
    getFunction(formDefaultValues.entity_id, formDefaultValues.entity_type);
  }, [formDefaultValues.entity_id, formDefaultValues.entity_type]);

  if (!formDefaultValues.entity_id || !formDefaultValues.entity_type)
    return null;

  return (
    <Card>
      <Card.Header>
        <Card.Title>{t("invoice_account")}</Card.Title>
      </Card.Header>

      <Card.Body>{actionTemplate}</Card.Body>

      <Card.Footer>
        <Button variant="primary" onClick={onSubmitFunction}>
          {t("save_changes")}
        </Button>
      </Card.Footer>
    </Card>
  );
}

export default InvoiceAccountMainTab;
